<template>
  <div id="data-view">
    <dv-full-screen-container>
      <div class="top">
        <div class="left">
          <div class="time">
            出库监控: {{ board_data.date.start }} ~
            {{ board_data.date.end }}
          </div>
          <div class="date">
            <!--                        <el-date-picker-->
            <!--                            size="mini"-->
            <!--                            type="date"-->
            <!--                            placeholder="选择日期">-->
            <!--                        </el-date-picker>-->
          </div>
        </div>
        <div class="right">
          <div class="time">
            {{ now_time }}
          </div>
        </div>
      </div>
      <dv-border-box-2 class="content">
        <div class="left">
          <dv-border-box-12 background-color="#232931" class="left-top">
            <div class="left-content">
              <div class="total" style="line-height: 30px">
                <el-row
                  >需发总件数: {{ board_data.wave_data.total_wave_num }}</el-row
                >
                <el-row>待发总件数: {{ board_data.wave_data.wave_num }}</el-row>
                <el-row
                  >实配总件数: {{ board_data.wave_data.allot_num }}</el-row
                >
              </div>
              <div class="list" style="margin-top: 30%; line-height: 40px">
                <el-row>
                  <el-col :span="12"
                    >在库所需: {{ board_data.wave_data.stock_in_pa }}</el-col
                  >
                  <el-col :span="12"
                    >单件分离: {{ board_data.wave_data.only_biao }}</el-col
                  >
                </el-row>
                <el-row>
                  <el-col :span="12"
                    >上架待拣:
                    {{ board_data.wave_data.sjed_waitpa_num }}</el-col
                  >
                  <el-col :span="12"
                    >质检分离: {{ board_data.wave_data.quality_biao }}</el-col
                  >
                </el-row>
                <el-row>
                  <el-col :span="12"
                    >越库分离: {{ board_data.wave_data.surpass_biao }}</el-col
                  >
                  <el-col :span="12"
                    >改标分离: {{ board_data.wave_data.label_biao }}</el-col
                  >
                </el-row>
              </div>
            </div>
            <div class="right-content">
              <dv-charts :option="option" />
            </div>
          </dv-border-box-12>
          <div style="height: 2%"></div>
          <dv-border-box-12 background-color="#232931" class="left-bottom">
            <div class="left-content">
              <div style="height: 60%">
                <el-row>
                  <el-col style="color: #ff8878">拣货进度</el-col>
                </el-row>
                <el-row>
                  <el-col style="color: #fff; font-size: 12px">任务数</el-col>
                </el-row>
                <dv-charts :option="ring" />
              </div>
              <div
                style="
                  height: 40%;
                  line-height: 40px;
                  text-align: center;
                  margin-top: 10%;
                "
              >
                <el-row>
                  <el-col
                    >拣货任务
                    {{ board_data.pad_data.staticis.all_pad_num }}</el-col
                  >
                </el-row>
                <el-row>
                  <el-col
                    >已拣货
                    {{
                      board_data.pad_data.staticis.all_complete_pad_num
                    }}</el-col
                  >
                </el-row>
                <el-row>
                  <el-col
                    >待拣货
                    {{ board_data.pad_data.staticis.all_wait_pad_num }}</el-col
                  >
                </el-row>
              </div>
            </div>
            <div class="right-content">
              <div style="text-align: right; height: 10%">
                <el-row>
                  <el-col
                    >拣货总波次数
                    {{ board_data.pad_data.total.pad_wave_num }}</el-col
                  >
                </el-row>
                <el-row>
                  <el-col>
                    拣货总件数
                    {{ board_data.pad_data.total.pad_sku_num }}</el-col
                  >
                </el-row>
              </div>
              <div v-if="board_data.pad_data.category" style="height: 90%">
                <el-row
                  v-for="item in board_data.pad_data.category"
                  :key="item.name"
                  style="margin-top: 5%"
                >
                  <el-col :span="16">
                    <el-progress
                      :stroke-width="16"
                      :percentage="item.rate"
                      :text-inside="true"
                    ></el-progress>
                  </el-col>
                  <el-col :span="8" style="font-size: 14px"
                    >{{ item.name }}({{ item.format }})</el-col
                  >
                </el-row>
              </div>
            </div>
          </dv-border-box-12>
        </div>
        <div class="middle">
          <dv-border-box-12 background-color="#232931" class="middle-top">
            <div style="width: 100%; height: 15%">
              <el-row>
                <el-col :span="4" style="color: #ff8878">中分进度</el-col>
                <el-col :span="20" style="height: 10px">
                  <el-button-group>
                    <el-button
                      size="mini"
                      :type="hg_id == 0 ? 'primary' : ''"
                      @click="setHgId(0)"
                      >全部分组</el-button
                    >
                    <el-button
                      v-for="item in config.halve_group"
                      :key="item.hg_id"
                      size="mini"
                      :type="hg_id == item.hg_id ? 'primary' : ''"
                      @click="setHgId(item.hg_id)"
                      >{{ item.hg_show_id }}</el-button
                    >
                  </el-button-group>
                </el-col>
              </el-row>
              <el-row>
                <el-col style="color: #fff; font-size: 12px">任务数</el-col>
              </el-row>
            </div>
            <div style="height: 85%; width: 100%">
              <div
                style="
                  line-height: 80px;
                  width: 50%;
                  text-align: left;
                  float: left;
                "
              >
                <el-row>
                  <el-col :span="12"
                    >中分任务
                    {{ board_data.surpass_data.staticis.all_num }}</el-col
                  >
                  <el-col :span="12"
                    >点货中
                    {{ board_data.surpass_data.staticis.talling_num }}
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12"
                    >已完成
                    {{ board_data.surpass_data.staticis.complete_num }}
                  </el-col>
                  <el-col :span="12"
                    >待拣货
                    {{ board_data.surpass_data.staticis.wait_num }}</el-col
                  >
                </el-row>
                <el-row>
                  <el-col :span="12"
                    >未完成
                    {{ board_data.surpass_data.staticis.unfinish_num }}
                  </el-col>
                  <el-col :span="12"
                    >可分播
                    {{ board_data.surpass_data.staticis.can_cut_num }}
                  </el-col>
                </el-row>
              </div>
              <div style="width: 50%; height: 100%; float: right">
                <dv-charts :option="hg_ring" />
              </div>
            </div>
          </dv-border-box-12>
          <div style="height: 2%"></div>
          <dv-border-box-12 background-color="#232931" class="middle-middle">
            <div style="width: 100%; height: 15%">
              <el-row>
                <el-col :span="4" style="color: #ff8878">分播进度</el-col>
                <el-col :span="20" style="height: 10px">
                  <el-button-group>
                    <el-button
                      size="mini"
                      :type="cut_type == 1 ? 'primary' : ''"
                      @click="setCutType(1)"
                      >按波次单</el-button
                    >
                    <el-button
                      size="mini"
                      :type="cut_type == 2 ? 'primary' : ''"
                      @click="setCutType(2)"
                      >按代采组</el-button
                    >
                    <el-button
                      size="mini"
                      :type="cut_type == 3 ? 'primary' : ''"
                      @click="setCutType(3)"
                      >按商家</el-button
                    >
                    <el-button
                      size="mini"
                      :type="cut_type == 4 ? 'primary' : ''"
                      @click="setCutType(4)"
                      >按汇总单</el-button
                    >
                  </el-button-group>
                </el-col>
              </el-row>
              <el-row>
                <el-col style="color: #fff; font-size: 12px">件数</el-col>
              </el-row>
            </div>
            <div style="width: 100%; height: 85%">
              <div style="width: 50%; height: 100%; float: left">
                <dv-capsule-chart
                  style="height: 60%; margin-top: 20%"
                  :config="cuting"
                ></dv-capsule-chart>
              </div>
              <div
                v-if="cut_type == 1"
                style="width: 50%; height: 100%; float: right"
              >
                <dv-charts :option="cut_ring" />
              </div>
            </div>
          </dv-border-box-12>
          <div style="height: 2%"></div>
          <dv-border-box-12 background-color="#232931" class="middle-bottom">
            <div style="width: 100%; height: 15%">
              <el-row>
                <el-col style="color: #ff8878">打包进度</el-col>
              </el-row>
              <el-row>
                <el-col style="color: #fff; font-size: 12px">波次数</el-col>
              </el-row>
            </div>
            <div style="height: 85%; width: 100%">
              <div
                style="width: 50%; height: 100%; float: left; line-height: 60px"
              >
                <el-row>
                  <el-col :span="8">待打包</el-col>
                  <el-col :span="8">{{
                    board_data.pack_data.wait_pack_num
                  }}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">已打包</el-col>
                  <el-col :span="8">{{
                    board_data.pack_data.packed_num
                  }}</el-col>
                </el-row>
                <el-row style="line-height: 30px; margin-top: 15px">
                  <el-row>
                    <el-col
                      >单件打包({{ board_data.pack_data.only_format }})</el-col
                    >
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-progress
                        :stroke-width="26"
                        :percentage="board_data.pack_data.only_rate"
                        :text-inside="true"
                      ></el-progress>
                    </el-col>
                  </el-row>
                </el-row>
              </div>
              <div style="width: 50%; height: 100%; float: right">
                <dv-charts :option="pack_ring" />
              </div>
            </div>
          </dv-border-box-12>
        </div>
        <div class="right">
          <dv-border-box-12 background-color="#232931" class="right-content">
            <div style="width: 100%; height: 6%">
              <el-row>
                <el-col
                  :span="14"
                  style="color: #fff; font-size: 20px; font-weight: bold"
                  >拣货效率
                </el-col>
                <el-col :span="10"
                  >平均效率{{
                    board_data.pad_efficiency.total_rate
                  }}件/人</el-col
                >
              </el-row>
              <el-row>
                <el-col>
                  <hr />
                </el-col>
              </el-row>
            </div>
            <div style="width: 100%; height: 90%">
              <div id="top" style="height: 20%">
                <dv-scroll-board :config="topFiveScroll" style="height: 100%" />
              </div>
              <div id="normal" style="height: 60%; margin-top: 2%">
                <dv-scroll-board
                  :config="normalScroll"
                  style="height: 100%"
                ></dv-scroll-board>
              </div>
              <div id="down" style="height: 20%; margin-top: 2%">
                <dv-scroll-board
                  :config="downFiveScroll"
                  style="height: 100%"
                ></dv-scroll-board>
              </div>
            </div>
          </dv-border-box-12>
        </div>
      </dv-border-box-2>
    </dv-full-screen-container>
  </div>
</template>

<script>
export default {
  name: "Board",
  data() {
    return {
      timer: null,
      date_timer: null,
      now_time: null,
      option: {
        series: [
          {
            type: "pie",
            data: [{ name: "测试", value: 100 }],
            insideLabel: {
              show: false,
            },
            outsideLabel: {
              show: true,
              formatter: "{name}{percent}%",
              style: {
                fontSize: 10,
              },
            },
          },
        ],
      },
      ring: {
        series: [
          {
            type: "gauge",
            startAngle: -Math.PI / 2,
            endAngle: Math.PI * 1.5,
            arcLineWidth: 13,
            radius: "80%",
            data: [{ name: "拣货进度", value: 0 }],
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            pointer: {
              show: false,
            },
            dataItemStyle: {
              lineCap: "round",
            },
            details: {
              show: true,
              formatter: "总进度:{value}%",
              style: {
                fill: "#1ed3e5",
                fontSize: 12,
              },
            },
          },
        ],
        color: ["#03d3ec"],
      },
      hg_ring: {
        series: [
          {
            type: "gauge",
            startAngle: -Math.PI / 2,
            endAngle: Math.PI * 1.5,
            arcLineWidth: 13,
            radius: "80%",
            data: [{ name: "中分进度", value: 0 }],
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            pointer: {
              show: false,
            },
            dataItemStyle: {
              lineCap: "round",
            },
            details: {
              show: true,
              formatter: "总进度:{value}%",
              style: {
                fill: "#1ed3e5",
                fontSize: 12,
              },
            },
          },
        ],
        color: ["#03d3ec"],
      },
      pack_ring: {
        series: [
          {
            type: "gauge",
            startAngle: -Math.PI / 2,
            endAngle: Math.PI * 1.5,
            arcLineWidth: 13,
            radius: "80%",
            data: [{ name: "打包进度", value: 0 }],
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            pointer: {
              show: false,
            },
            dataItemStyle: {
              lineCap: "round",
            },
            details: {
              show: true,
              formatter: "总进度:{value}%",
              style: {
                fill: "#1ed3e5",
                fontSize: 12,
              },
            },
          },
        ],
        color: ["#03d3ec"],
      },
      cut_ring: {
        series: [
          {
            type: "gauge",
            startAngle: -Math.PI / 2,
            endAngle: Math.PI * 1.5,
            arcLineWidth: 13,
            radius: "80%",
            data: [{ name: "分播进度", value: 0 }],
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            pointer: {
              show: false,
            },
            dataItemStyle: {
              lineCap: "round",
            },
            details: {
              show: true,
              formatter: "总进度:{value}%",
              style: {
                fill: "#1ed3e5",
                fontSize: 12,
              },
            },
          },
        ],
        color: ["#03d3ec"],
      },
      cuting: {
        data: [
          {
            name: "设备分播",
            value: 167,
          },
          {
            name: "快手分播",
            value: 123,
          },
          {
            name: "PC分播",
            value: 98,
          },
        ],
        unit: "件",
        showValue: true,
      },
      topFiveScroll: {
        header: ["#", "姓名", "时效", "总量"],
        data: [],
        index: false,
        columnWidth: [50],
        headerHeight: 20,
        align: ["center"],
      },
      normalScroll: {
        data: [],
        columnWidth: [50],
        headerHeight: 20,
        align: ["center"],
        rowNum: 15,
      },
      downFiveScroll: {
        data: [],
        index: false,
        columnWidth: [50],
        headerHeight: 20,
        align: ["center"],
      },
      board_data: {
        wave_data: {
          wave_num: 0,
        },
        date: {
          start: "",
        },
      },
      hg_id: 0,
      cut_type: 1,
      config: {
        halve_group: [],
      },
    };
  },
  computed: {},
  watch: {
    board_data() {
      this.option.series[0].data = this.board_data.wave_data.pie_data;
      this.ring.series[0].data = this.board_data.pad_data.staticis.rate;
      this.hg_ring.series[0].data = this.board_data.surpass_data.rate;
      this.cuting.data = this.board_data.cut_log.staticis;
      this.cut_ring.series[0].data = this.board_data.cut_log.rate;
      this.pack_ring.series[0].data = this.board_data.pack_data.rate;
      this.topFiveScroll.data = this.board_data.pad_efficiency.top_five;
      this.normalScroll.data = this.board_data.pad_efficiency.normal;
      this.downFiveScroll.data = this.board_data.pad_efficiency.last_five;
      this.option = { ...this.option };
      this.ring = { ...this.ring };
      this.hg_ring = { ...this.hg_ring };
      this.cuting = { ...this.cuting };
      this.cut_ring = { ...this.cut_ring };
      this.pack_ring = { ...this.pack_ring };
      this.topFiveScroll = { ...this.topFiveScroll };
      this.normalScroll = { ...this.normalScroll };
      this.downFiveScroll = { ...this.downFiveScroll };
    },
  },
  mounted() {
    this.getBoardData();
    if (this.timer) {
      clearInterval(this.timer);
    } else {
      this.timer = setInterval(() => {
        this.getBoardData();
      }, 15000);
    }
    if (this.date_timer) {
      clearInterval(this.timer);
    } else {
      this.date_timer = setInterval(() => {
        this.setDate();
      }, 500);
    }
  },
  created() {
    this.getConfig();
  },
  destroyed() {
    clearInterval(this.timer);
    clearInterval(this.date_timer);
  },
  methods: {
    setDate() {
      let date = new Date();
      let hour = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();
      hour = hour < 10 ? "0" + hour : hour;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      this.now_time = hour + ":" + minutes + ":" + seconds;
    },
    getBoardData() {
      this.$http
        .post(
          "/erp/Monitor/boardData",
          {
            hg_id: this.hg_id,
            cut_type: this.cut_type,
          },
          {
            no_loading: true,
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.board_data = res.data.data;
          } else {
            this.$message.e(res.data.msg);
          }
        });
    },
    getConfig() {
      this.$http.post("/erp/Monitor/getConfig", {}).then((res) => {
        if (res.data.code == 200) {
          this.config = res.data.data;
        }
      });
    },
    randomExtend(minNum, maxNum) {
      if (arguments.length === 1) {
        return parseInt(Math.random() * minNum + 1, 10);
      } else {
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
      }
    },
    format() {
      return "1500/3000";
    },
    setHgId(hg_id) {
      this.hg_id = hg_id;
    },
    setCutType(type) {
      this.cut_type = type;
    },
  },
};
</script>

<style>
#data-view {
  width: 100%;
  height: 100%;
  background-color: #191e23;
  color: #fff;
}

#data-view .el-row {
  margin-bottom: 0;
}

#data-view #dv-full-screen-container {
  background-color: #191e23;
  background-size: 100% 100%;
  box-shadow: 0 0 3px blue;
  display: flex;
  flex-direction: column;
}

#data-view .top {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: end;
  background-color: #232931;
}

#data-view .top .left {
  float: left;
  margin-left: 20px;
  padding: 12px;
  display: inline-flex;
}

#data-view .top .left .date {
  margin-left: 15px;
}

#data-view .top .right {
  float: right;
  margin-right: 20px;
  padding: 12px;
}

#data-view .content {
  height: calc(100% - 80px);
}

#data-view .content .border-box-content {
  box-sizing: border-box;
  display: flex;
}

#data-view .content .left {
  width: 40%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
}

#data-view .content .left .left-top {
  height: 39%;
}

#data-view .content .left .left-top .left-content {
  width: 35%;
  height: 100%;
}

#data-view .content .left .left-top .right-content {
  width: 65%;
  height: 100%;
  float: right;
}

#data-view .content .left .left-top .border-box-content {
  padding: 20px;
}

#data-view .content .left .left-bottom {
  height: 59%;
}

#data-view .content .left .left-bottom .left-content {
  width: 35%;
  height: 100%;
  float: left;
}

#data-view .content .left .left-bottom .right-content {
  width: 65%;
  height: 100%;
  float: right;
}

#data-view .content .left .left-bottom .border-box-content {
  padding: 20px;
}

#data-view .content .middle {
  width: 30%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
}

#data-view .content .middle .border-box-content {
  flex-direction: column;
  box-sizing: border-box;
}

#data-view .content .middle .middle-top {
  height: 32%;
}

#data-view .content .middle .middle-top .border-box-content {
  padding: 20px;
}

#data-view .content .middle .middle-middle {
  height: 32%;
}

#data-view .content .middle .middle-middle .border-box-content {
  padding: 20px;
}

#data-view .content .middle .middle-bottom {
  height: 32%;
}

#data-view .content .middle .middle-bottom .border-box-content {
  padding: 20px;
}

#data-view .content .right {
  width: 30%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
}

#data-view .content .right .right-content {
  height: 100%;
}

#data-view .content .right .right-content .border-box-content {
  padding: 20px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/monitorscreen/Board.vue